import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { FiTrash2, FiRotateCw, FiEdit3 } from 'react-icons/fi';
import Table from '../shared/table/Table';
import { useNavigate, Link } from 'react-router-dom';   
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify"; // 

const TrashLeadsTable = () => {
  const [items, setItems] = useState([]);
  const [perms, setPerms] = useState([]);
  const navigate = useNavigate();                   

  
  const lang = useUserLanguage();
  const { translations } = useTranslations(lang);
  const t = (key, def) => translations[key] || def;


useEffect(() => {
  (async() => {
    try {
      const token = localStorage.getItem("admin_token");
      const [trashRes, permRes] = await Promise.all([
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/leads/trash`, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/my-permissions`, {
          headers: { Authorization: `Bearer ${token}` }
        })
      ]);
      console.log('Çöp kutusu verisi:', trashRes.data);
      setItems(trashRes.data);
      setPerms(permRes.data.permissions || []);
    } catch (err) {
      console.error("Çöp kutusu yüklenirken hata:", err);
    }
  })();
}, []);


  const modulePerm = perms.find(p=>p.module_key==="static_admin_accounts")||{};
  const canRestore = modulePerm.full_access || modulePerm.edit_permission;
  const canDestroy = modulePerm.full_access || modulePerm.delete_permission;
  const canEdit     = modulePerm.edit_permission   || modulePerm.full_access;


  const handleRestore = (id) => {
    confirmAlert({
      title: t("RESTORE_CONFIRM_TITLE"),
      message: t("RESTORE_CONFIRM_MSG"),
      buttons: [
        {
          label: t("YES_RESTORE"),
          onClick: async () => {
            try {
              const token = localStorage.getItem("admin_token");
              await axios.put(
                `${process.env.REACT_APP_API_BASE_URL}/api/admin/leads/restore/${id}`,
                {},
                { headers: { Authorization: `Bearer ${token}` } }
              );
              setItems(prev => prev.filter(i => i.id !== id));
              toast.success(t("SUCCESS_USER_RESTORED"));
            } catch (err) {
              console.error(err);
              toast.error(t("ERROR_USER_RESTORE_FAILED"));
            }
          },
        },
        {
          label: t("CANCEL", "İptal"),
          onClick: () => toast.info(t("RESTORE_CANCELLED")),
        },
      ],
    });
  };
  
  const handleDestroy = (id) => {
    confirmAlert({
      title: t("DESTROY_CONFIRM_TITLE"),
      message: t("DESTROY_CONFIRM_MSG"),
      buttons: [
        {
          label: t("YES_DESTROY"),
          onClick: async () => {
            try {
              const token = localStorage.getItem("admin_token");
              await axios.delete(
                `${process.env.REACT_APP_API_BASE_URL}/api/admin/leads/permanent-delete/${id}`,
                { headers: { Authorization: `Bearer ${token}` } }
              );
              setItems(prev => prev.filter(i => i.id !== id));
              toast.success(t("SUCCESS_USER_DESTROYED"));
            } catch (err) {
              console.error(err);
              toast.error(t("ERROR_USER_DESTROY_FAILED"));
            }
          },
        },
        {
          label: t("CANCEL"),
          onClick: () => toast.info(t("DESTROY_CANCELLED")),
        },
      ],
    });
  };
  
  const columns = useMemo(() => [
    { accessorKey:'id', header:t("TABLE_ID_LABEL"), size:60 },
    {
      accessorKey: 'customer.img',
      header: t("TABLE_PROFILE_IMAGE_LABEL"),
      size: 80,
      enableSorting: false,
      cell: info => {
        const imgPath = info.row.original.customer?.img;
        const src = imgPath
          ? `${process.env.REACT_APP_API_BASE_URL}${imgPath}`
          : '${process.env.REACT_APP_API_BASE_URL}/uploads/avatars/default.svg';
        return (
          <img
            src={src}
            alt="Avatar"
            onError={e => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = '${process.env.REACT_APP_API_BASE_URL}/uploads/avatars/default.svg';
            }}
            style={{ width: 40, height: 40, borderRadius: 20 }}
          />
        );
      }
    },
    { accessorKey:'customer.name', header:t("TABLE_NAME_LABEL"), size:200 },
    { accessorKey:'email', header:t("TABLE_EMAIL_LABEL"), size:250 },
    { accessorKey:'phone', header:t("TABLE_PHONE_LABEL"), size:150 },
    { accessorKey:'role_name', header:t("TABLE_ROLE_LABEL"), size:150 },
    {
      accessorKey:'created_at',
      header:t("TABLE_CREATED_AT"),
      meta: { headerClassName: 'text-end', className: 'text-end date-column' },
      cell: (info) => {
        const rawDate = info.getValue();
        const formattedDate = new Date(rawDate).toLocaleDateString('en-GB');
        return (
          <div style={{ textAlign: 'end', width: '125px' }}>
            {formattedDate}
          </div>
        );
      },
      size:160
    },
    {
      accessorKey:'deleted_at',
      header:t("TABLE_DELETED_AT"),
      meta: { headerClassName: 'text-end', className: 'text-end date-column' },
      cell: (info) => {
        const rawDate = info.getValue();
        const formattedDate = new Date(rawDate).toLocaleDateString('en-GB');
        return (
          <div style={{ textAlign: 'end', width: '125px' }}>
            {formattedDate}
          </div>
        );
      },
      size:160
    },
    {
      accessorKey:'actions',
      header:t("TABLE_ACTIONS_LABEL"),
      enableSorting:false,size:140,
      cell:info => {
        const id = info.row.original.id;
        return (
          <div className="d-flex gap-2 justify-content-end">
            {canEdit && (
              <Link
                to={`/profile/edit/${id}`}
                className="avatar-text avatar-md text-success bg-soft-success border-soft-success"
                title={t("EDIT")}
              >
                <FiEdit3/>
              </Link>
            )}
            {canRestore && (
              <button
                className="avatar-text avatar-md text-primary bg-soft-primary border-soft-primary"
                title={t("RESTORE")}
                onClick={()=>handleRestore(id)}
              ><FiRotateCw/></button>
            )}
            
            {canDestroy && (
              <button
                className="avatar-text avatar-md text-danger bg-soft-danger border-soft-danger"
                title={t("DELETE_PERMANENT")}
                onClick={()=>handleDestroy(id)}
              ><FiTrash2/></button>
            )}
          </div>
        );
      }
    }
  ], [t, canRestore, canDestroy, items]);

  return <Table data={items} columns={columns} />;
};

export default TrashLeadsTable;
